import React from 'react';

const Check = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fill="none" fillRule="evenodd">
      <g fill="#108EE9">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm-4.287 9.297c-.393-.388-1.027-.383-1.415.01-.388.392-.383 1.024.01 1.411l3.045 2.997c.371.366.962.385 1.357.044l6.954-6.003c.418-.36.464-.991.102-1.408-.361-.417-.993-.463-1.41-.102l-6.256 5.4-2.387-2.35z"
                  transform="translate(-6269 -5999) translate(5129 4806) translate(264 995) translate(788 128) translate(88 70)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Check;
